import React from "react";
import "./Deposite_info_card.css";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Deposite_info_card() {
  return (
    <>
      <section className="Deposite_info_card">
        {/* Info Box */}
        <div className="Withdraw_deposite_bank_info deposit_card_box">
          <div className="info_box">
            <div className="section_header">
              <span className="icon_box">
                <FontAwesomeIcon icon={faBook} />
              </span>
              <h4>Recharge Instructions</h4>
            </div>

            <p>
              <span className="red">•</span> If the transfer time is up, please
              fill out the deposit form again
            </p>
            <p>
              <span className="red">•</span>The transfer amount must match the
              order you created, otherwise the money cannot be credited
              successfully.
            </p>
            <p>
              <span className="red">•</span> If you transfer the wrong amount,
              our company will not be responsible for the lost amount!
            </p>
            <p>
              <span className="red">•</span> Note: do not cancel the deposit
              order after the money has been transferred.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Deposite_info_card;
